
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {FilterUint64} from './FilterUint64';
import {FieldModelFilterUint64} from './FilterUint64';
import {FilterString} from './FilterString';
import {FieldModelFilterString} from './FilterString';

/**
 * OrdersDisjunctionFiltration struct
 */
class OrdersDisjunctionFiltration {
  /**
   * Initialize struct
   * @param {FilterUint64=} orderId
   * @param {FilterUint64=} login
   * @param {FilterString=} accountGroupName
   * @constructor
   */
  constructor (orderId = null, login = null, accountGroupName = null) {
    this.OrderId = orderId
    this.Login = login
    this.AccountGroupName = accountGroupName
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrdersDisjunctionFiltration}
   * @param {!OrdersDisjunctionFiltration} other Other struct
   * @returns {!OrdersDisjunctionFiltration} This struct
   */
  copy (other) {
    if (other.OrderId != null) {
      this.OrderId = FilterUint64.fromObject(other.OrderId)
    } else {
      this.OrderId = null
    }
    if (other.Login != null) {
      this.Login = FilterUint64.fromObject(other.Login)
    } else {
      this.Login = null
    }
    if (other.AccountGroupName != null) {
      this.AccountGroupName = FilterString.fromObject(other.AccountGroupName)
    } else {
      this.AccountGroupName = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrdersDisjunctionFiltration}
   * @returns {!OrdersDisjunctionFiltration} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrdersDisjunctionFiltrationModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrdersDisjunctionFiltrationModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrdersDisjunctionFiltration}
   * @param {!OrdersDisjunctionFiltration} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrdersDisjunctionFiltration)) {
      throw new TypeError('Instance of OrdersDisjunctionFiltration is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrdersDisjunctionFiltration}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      OrderId: ((this.OrderId != null) ? this.OrderId : null),
      Login: ((this.Login != null) ? this.Login : null),
      AccountGroupName: ((this.AccountGroupName != null) ? this.AccountGroupName : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrdersDisjunctionFiltration.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrdersDisjunctionFiltration} other Object value
   * @returns {!OrdersDisjunctionFiltration} Created struct
   */
  static fromObject (other) {
    return new OrdersDisjunctionFiltration().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrdersDisjunctionFiltration}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrdersDisjunctionFiltration.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrdersDisjunctionFiltration}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 174
  }
}

export { OrdersDisjunctionFiltration };

/**
 * Fast Binary Encoding OrdersDisjunctionFiltration field model
 */
class FieldModelOrdersDisjunctionFiltration extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.OrderId = new fbe.FieldModelOptional(new FieldModelFilterUint64(buffer, 4 + 4), buffer, 4 + 4)
    this.Login = new fbe.FieldModelOptional(new FieldModelFilterUint64(buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize), buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize)
    this.AccountGroupName = new fbe.FieldModelOptional(new FieldModelFilterString(buffer, this.Login.fbeOffset + this.Login.fbeSize), buffer, this.Login.fbeOffset + this.Login.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.OrderId.fbeSize + this.Login.fbeSize + this.AccountGroupName.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.OrderId.fbeExtra + this.Login.fbeExtra + this.AccountGroupName.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrdersDisjunctionFiltration.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 174
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.Login.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Login.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.AccountGroupName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountGroupName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupName.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @param {!OrdersDisjunctionFiltration} fbeValue Default value, defaults is new OrdersDisjunctionFiltration()
   * @returns {!OrdersDisjunctionFiltration} OrdersDisjunctionFiltration value
   */
  get (fbeValue = new OrdersDisjunctionFiltration()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @param {!OrdersDisjunctionFiltration} fbeValue OrdersDisjunctionFiltration value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderId.fbeSize) <= fbeStructSize) {
      fbeValue.OrderId = this.OrderId.get()
    } else {
      fbeValue.OrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.Login.fbeSize) <= fbeStructSize) {
      fbeValue.Login = this.Login.get()
    } else {
      fbeValue.Login = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.AccountGroupName.fbeSize) <= fbeStructSize) {
      fbeValue.AccountGroupName = this.AccountGroupName.get()
    } else {
      fbeValue.AccountGroupName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupName.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @param {!OrdersDisjunctionFiltration} fbeValue OrdersDisjunctionFiltration value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrdersDisjunctionFiltration}
   * @param {OrdersDisjunctionFiltration} fbeValue OrdersDisjunctionFiltration value
   */
  setFields (fbeValue) {
    this.OrderId.set(fbeValue.OrderId)
    this.Login.set(fbeValue.Login)
    this.AccountGroupName.set(fbeValue.AccountGroupName)
  }
}

export { FieldModelOrdersDisjunctionFiltration };

/**
 * Fast Binary Encoding OrdersDisjunctionFiltration model
 */
class OrdersDisjunctionFiltrationModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrdersDisjunctionFiltration(this.buffer, 4)
  }

  /**
   * Get the OrdersDisjunctionFiltration model
   * @this {!OrdersDisjunctionFiltrationModel}
   * @returns {!FieldModelOrdersDisjunctionFiltration} model OrdersDisjunctionFiltration model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrdersDisjunctionFiltrationModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrdersDisjunctionFiltrationModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrdersDisjunctionFiltrationModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrdersDisjunctionFiltrationModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrdersDisjunctionFiltration.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrdersDisjunctionFiltrationModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrdersDisjunctionFiltrationModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrdersDisjunctionFiltrationModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrdersDisjunctionFiltrationModel}
   * @param {!OrdersDisjunctionFiltration} value OrdersDisjunctionFiltration value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrdersDisjunctionFiltrationModel}
   * @param {!OrdersDisjunctionFiltration} value OrdersDisjunctionFiltration value, defaults is new OrdersDisjunctionFiltration()
   * @return {!object} Deserialized OrdersDisjunctionFiltration value and its size
   */
  deserialize (value = new OrdersDisjunctionFiltration()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrdersDisjunctionFiltration(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrdersDisjunctionFiltration(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrdersDisjunctionFiltrationModel}
   * @param {!number} prev Previous OrdersDisjunctionFiltration model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrdersDisjunctionFiltrationModel };
